import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class AppProgressBarService {
    change = new Subject<boolean>();
    constructor() {}

    get() {
        return this.change.asObservable();
    }
    set(toggle: boolean) {
        this.change.next(toggle);
    }
}
